import { useNavigate } from "react-router-dom";
import Footer from "./footer";
import Navbar from "./navbar";

export default function AppLayout({ children }) {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col relative">
            <img onClick={() => navigate('/')} src="/logo.svg" alt="NSS Logo" loading="lazy" className="absolute top-5 left-5 z-10 object-contain w-[5em]" />
            <Navbar />
            <div className="min-h-[90vh]">
                {children}
            </div>
            <Footer />
        </div>
    )
}